<div class="w-100 flex-col justify-start items-stretch">
  <button mat-stroked-button color="primary" class="uppercase" (click)="onAddRowClick()">
    Add Row
  </button>
  <mat-accordion class="w-100" multi="true">
    @for (row of rows; track $index; let i = $index; let isLast = $last) {
      <mat-expansion-panel >
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="w-100 flex-row space-between items-center text-muted">
              <span class="text-bold">Row index: {{row.rowIndex+1}}</span>
              @if (isLast) {
                <button mat-icon-button class="delete-button" (click)="onDeleteRowClick(row)" matTooltip="Delete Row">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              }
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @if (initialized) {
          <app-edit-row [availableMetadataInfo]="availableMetadataInfo()" [availableCustomerVariables]="availableCustomerVariables()" [row]="row" [fileType]="fileType" [fieldDelimiter]="fieldDelimiter" (onValueChanged)="onRowValueChanged($event)"></app-edit-row>
        }
      </mat-expansion-panel>
    }
  </mat-accordion>
</div>
